import { TextKey } from '@mews-commander/enums';
import { PortfolioEnterpriseGroupResult } from '@mews-commander/data-access';
import { MAX_SMALL_INPUT_TEXT_LENGTH } from '@mews-commander/constants';
import { maxTextLength, presence, ValidationRules } from '@mews-commander/legacy-form';
import { FIELD_NAMES, FormValues } from './types/Form';

type Constraints = {
    [K in keyof FormValues]?: ValidationRules;
};

export enum FORM_TYPE {
    CREATE_NEW = 'createNew',
    ADD_TO_EXISTING = 'addToExisting',
    EDIT = 'edit',
}

const formConstraints = (
    propertyGroups: PortfolioEnterpriseGroupResult[],
    selectedPropertyGroup?: PortfolioEnterpriseGroupResult
): Constraints => ({
    [FIELD_NAMES.NAME]: {
        presence,
        length: maxTextLength(MAX_SMALL_INPUT_TEXT_LENGTH, TextKey.PropertyAddGroupNameFieldLimit),
        caseSensitiveExclusion: {
            within: selectedPropertyGroup
                ? propertyGroups
                      .filter((propertyGroup) => propertyGroup.id !== selectedPropertyGroup.id)
                      .map((propertyGroup) => propertyGroup.name)
                : propertyGroups.map((propertyGroup) => propertyGroup.name),
            message: TextKey.PropertyGroupNameExists,
        },
    },
});

const addToExistingFormConstraints: Constraints = {
    [FIELD_NAMES.PROPERTY_GROUP_ID]: {
        presence,
    },
};

export const getConstraints = (
    formType: FORM_TYPE,
    propertyGroups: PortfolioEnterpriseGroupResult[],
    selectedPropertyGroup?: PortfolioEnterpriseGroupResult
): Constraints => {
    if (formType === FORM_TYPE.ADD_TO_EXISTING) {
        return addToExistingFormConstraints;
    }

    return formConstraints(propertyGroups, selectedPropertyGroup);
};
